import { post, get } from '../util/crmAxios';
import { Message } from 'element-ui';

const objParam = {
        "Where": {
            "SearchType": 1
        },
        "PageIndex": 1,
        "PageSize": 10,
    }
    // 通话记录列表
export const getCallRecordList = (objParam) => post('/CallCenter/QueryCallRecord', objParam);

//获取分机状态
export const getExtStatus = (objParam) => post('/CallCenter/QueryExtInfo', objParam);

//获取单个分机状态
export const getSingleExtStatus = (objParam) => post('/CallCenter/GetExtStatus', objParam);

//拨打电话
export const sendCall = parameters => post('/CallCenter/SendCall', parameters);

//获取通时通次
export const getCallInfo = parameters => get('/CallCenter/GetCallInfo', parameters);

//签入 签出
export const signOperate = parameters => post('/CallCenter/UserSign', parameters);

//挂断电话
export const hangup = parameters => post('/CallCenter/HandupCall', parameters);

// 获取手机号码明文
export const GetContactByUid = parameters => get('/CustomCenter/GetContactById', parameters);

//电话监听
export const monitorCall = parameters => post('/CallCenter/CallMonitor', parameters);

//添加通话记录
export const addCallRecord = parameters => post('/AliCC/AddRecord', parameters);

//更新通话记录
export const updateCallRecords = parameters => post('/AliCC/UpdateRecordsByIds', parameters);

//获取通话排行
export const queryCallRange = (objParam) => post('/CallCenter/QueryCallRange', objParam);

//验证ali token
export const ccValidToken = (parameters) => get('/alicc/ValidToken', parameters);

//获取录音对应文字
export const queryAsrFile = (parameters) => get('/CallCenter/QueryAsrFile', parameters);

//更新拨打次数
export const updateConnect=(parameters) => post('/CallCenter/SendCall', parameters);

//更新接通次数
export const updateConnected=(parameters) => post('/CallCenter/ConnectCall', parameters);

// 汉天呼叫
const OperationUrl = '//192.168.0.21/Operation'
// const OperationUrl = '//192.168.0.240:8088'
// 拨打
export const Operation = (objParam) => get(OperationUrl + '/callengine/http/operation', objParam)
// 获取外显号码
export const GetDisplayNos = (objParam) => get('/CallCenter/GetDisplayNos', objParam)

//拨打电话
export const sendCallUp=(parameters) => post('/CallCenter/CallUp', parameters);

//挂断电话
export const callHangUp=(parameters) => post('/CallCenter/HangUp', parameters);

//监听
export const hantianSpy=(parameters) => post('/CallCenter/HanTianSpy', parameters);

//获取通话状态
export const getCallStatus=(parameters) => post('/CallCenter/SearchCallStatus', parameters);

// 拨打电话-更新线索是否拨打
export const DialClue=(parameters) => post('/ClueFollow/DialClue', parameters);
